<template>
  <el-dialog
          :title="title"
          :visible="localVisible"
          :before-close="handleClose"
          width="880px"
          custom-class="proxy-user-dialog"
          :close-on-click-modal="false"
  >
    <!-- 代理信息展示区 -->
    <div class="proxy-info-section">
      <div class="info-card">
        <div class="info-header">
          <i class="el-icon-user info-icon"></i>
          <span class="info-title">代理信息</span>
        </div>
        <div class="info-content">
          <div class="info-item">
            <span class="info-label">代理名称：</span>
            <span class="info-value">{{ formData.real_name || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">代理编码：</span>
            <span class="info-value badge">{{ formData.sn || '--' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 表单区域 -->
    <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="100px"
            size="small"
            class="proxy-user-form"
    >
      <div class="form-section">
        <div class="section-header">
          <i class="el-icon-edit section-icon"></i>
          <span class="section-title">账户信息</span>
        </div>

        <div class="form-row">
          <el-form-item label="工号"  class="form-item">
            <el-input
                    v-model="form.sn"
                    autocomplete="off"
                    placeholder="请输入员工工号"
                    prefix-icon="el-icon-postcard"
                    clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="用户名" prop="user_name" class="form-item">
            <el-input
                    v-model="form.user_name"
                    autocomplete="off"
                    placeholder="11位数字或字母"
                    prefix-icon="el-icon-user"
                    clearable
            >
              <template slot="append">
                <el-tooltip content="11位数字或字母，不区分大小写" placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
            </el-input>
          </el-form-item>
        </div>

        <!-- 密码区域 -->
        <div  class="password-section">
          <div class="form-row">
            <el-form-item label="密码" prop="pass" class="form-item">
              <el-input
                      v-model="form.pass"
                      type="password"
                      autocomplete="new-password"
                      placeholder="请输入密码"
                      prefix-icon="el-icon-lock"
                      show-password
                      clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="确认密码" prop="repass" class="form-item">
              <el-input
                      v-model="form.repass"
                      type="password"
                      autocomplete="new-password"
                      placeholder="请再次输入密码"
                      prefix-icon="el-icon-lock"
                      show-password
                      clearable
              ></el-input>
            </el-form-item>
          </div>

          <div class="password-tips">
            <i class="el-icon-warning-outline"></i>
            <span>密码需至少6位，包含字母和数字</span>
          </div>
        </div>
      </div>

      <!-- 权限设置区域 -->
      <div class="form-section">
        <div class="section-header">
          <i class="el-icon-setting section-icon"></i>
          <span class="section-title">权限设置</span>
        </div>

        <div class="form-row">
          <el-form-item label="角色名称" prop="proxy_role_id" class="form-item">
            <el-select
                    v-model="form.proxy_role_id"
                    placeholder="请选择角色"
                    style="width: 100%"
                    @change="changeRoleNameValue"
                    clearable
            >
              <el-option
                      v-for="item in roleNameData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      class="role-option"
              >
                <span class="role-name">{{ item.name }}</span>
                <span class="role-desc" v-if="item.description">（{{ item.description }}）</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账户状态" prop="status" class="form-item">
            <el-select
                    v-model="form.status"
                    placeholder="请选择状态"
                    style="width: 100%"
                    clearable
            >
              <el-option label="启用" :value="1">
                <span class="status-badge active">
                  <i class="el-icon-success"></i>
                  启用
                </span>
              </el-option>
              <el-option label="禁用" :value="0">
                <span class="status-badge inactive">
                  <i class="el-icon-error"></i>
                  禁用
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <!-- 对话框底部 -->
    <div slot="footer" class="dialog-footer">
      <el-button
              @click="reset_dialogForm('form')"
              class="cancel-btn"
              size="medium"
      >
        <i class="el-icon-close"></i>
        取 消
      </el-button>
      <el-button
              type="primary"
              @click="submitForm('form')"
              class="submit-btn"
              size="medium"
      >
        <i class="el-icon-check"></i>
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { hexMD5 } from "@/utils/md5";

  export default {
    name: 'eProxyUser',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: () => ({}),
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data() {
      // 密码验证规则
      const validatePassword = (rule, value, callback) => {
        if (!this.id && !value) {
          callback(new Error('请输入密码'));
        } else if (value && value.length < 6) {
          callback(new Error('密码长度不能少于6位'));
        } else if (value && !/^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(value)) {
          callback(new Error('密码必须包含字母和数字'));
        } else {
          callback();
        }
      };

      const validateConfirmPassword = (rule, value, callback) => {
        if (!this.id && !value) {
          callback(new Error('请确认密码'));
        } else if (value !== this.form.pass) {
          callback(new Error('两次输入密码不一致'));
        } else {
          callback();
        }
      };

      return {
        id: '',
        roleNameData: [],
        localVisible: false,
        rules: {

          user_name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { pattern: /^[A-Za-z0-9]{11}$/, message: '用户名必须为11位字母或数字', trigger: 'blur' }
          ],
          pass: [
            { validator: validatePassword, trigger: 'blur' }
          ],
          repass: [
            { validator: validateConfirmPassword, trigger: 'blur' }
          ],
          proxy_role_id: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ]
        },
        form: {
          sn: "",
          user_name: '',
          mobile: '',
          sex: '',
          company_department_id: '',
          proxy_role_id: '',
          address: '',
          education: '',
          status: '',
          role_name: '',
          employee_id: '',
          pass: '',
          repass: '',
          proxy_id: sessionStorage.getItem('proxy_id'),
        },
      };
    },
    watch: {
      visible(val) {
        this.localVisible = val;
        if (val) {
          this.getRoleList();
          // 如果是编辑模式，填充表单数据
          if (this.formData.id) {
            this.form.proxy_id = this.formData.id;
            // this.form = {
            //   ...this.form,
            //   proxy_role_id: this.formData.role_id
            // };
          } else {
            // 重置表单
            this.resetForm();
          }
        }
      },
    },
    methods: {
      handleClose() {
        this.closeForm();
      },

      resetForm() {
        this.id = '';
        this.form = {
          sn: "",
          user_name: '',
          mobile: '',
          sex: '',
          company_department_id: '',
          proxy_role_id: '',
          address: '',
          education: '',
          status: '',
          role_name: '',
          employee_id: '',
          pass: '',
          repass: '',
          proxy_id: sessionStorage.getItem('proxy_id'),
        };
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
      },

      reset_dialogForm() {
        this.resetForm();
        this.closeForm();
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveUser();
          } else {
            this.$message.warning('请完善表单信息');
            return false;
          }
        });
      },

      async saveUser() {
        try {
          const param = {
            sn: this.form.sn,
            user_name: this.form.user_name,
            company_department_id: this.form.company_department_id,
            role_id: this.form.proxy_role_id,
            status: this.form.status,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            proxy_id: this.form.proxy_id,
          };

          // 如果是新增，添加密码信息

            param.pass = hexMD5(this.form.pass);
            param.repass = hexMD5(this.form.repass);


          // 可选字段
          if (this.form.employee_id) param.employee_id = this.form.employee_id;
          if (this.form.mobile) param.mobile = this.form.mobile;
          if (this.form.sex !== '') param.sex = this.form.sex;
          if (this.form.address) param.address = this.form.address;
          if (this.form.education) param.education = this.form.education;

          const api =  'proxyUserSave';
          const response = await this.$axios[api](param);

          if (response.code === 200) {
            this.$message.success(response.msg || '操作成功');
            this.$emit('success');
            this.closeForm();
          } else {
            this.$message.error(response.msg || '操作失败');
          }
        } catch (error) {
          console.error('保存用户失败:', error);
          this.$message.error('操作失败，请稍后重试');
        }
      },

      getRoleList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          proxy_id: sessionStorage.getItem('proxy_id')
        };

        this.$axios.getProxyRoleList(param).then(res => {
          if (res.code === 200) {
            this.roleNameData = res.data;
          }
        }).catch(error => {
          console.error('获取角色列表失败:', error);
        });
      },

      changeRoleNameValue(value) {
        const role = this.roleNameData.find(item => item.id === value);
        if (role) {
          this.form.role_name = role.name;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .proxy-user-dialog {
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    .el-dialog__header {
      background: linear-gradient(135deg, #1890ff 0%, #52c41a 100%);
      padding: 20px 24px;

      .el-dialog__title {
        color: white;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }

      .el-dialog__headerbtn {
        top: 22px;

        .el-dialog__close {
          color: white;
          font-size: 20px;

          &:hover {
            color: #f0f0f0;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 20px 24px;
      max-height: 70vh;
      overflow-y: auto;
    }

    .el-dialog__footer {
      padding: 16px 24px;
      border-top: 1px solid #e8e8e8;
      background: #fafafa;
    }
  }

  // 代理信息卡片
  .proxy-info-section {
    margin-bottom: 24px;

    .info-card {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 10px;
      padding: 16px;
      border-left: 4px solid #1890ff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      .info-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .info-icon {
          color: #1890ff;
          font-size: 18px;
          margin-right: 8px;
        }

        .info-title {
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
      }

      .info-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;

        .info-item {
          display: flex;
          align-items: center;

          .info-label {
            color: #666;
            font-size: 14px;
            min-width: 70px;
          }

          .info-value {
            color: #333;
            font-weight: 500;

            &.badge {
              background: #1890ff;
              color: white;
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  // 表单样式
  .proxy-user-form {
    .form-section {
      margin-bottom: 24px;

      .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;

        .section-icon {
          color: #1890ff;
          font-size: 16px;
          margin-right: 8px;
        }

        .section-title {
          font-size: 15px;
          font-weight: 600;
          color: #333;
        }
      }

      .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }
      }

      .form-item {
        margin-bottom: 16px;

        ::v-deep .el-form-item__label {
          color: #666;
          font-weight: 500;
        }
      }
    }

    .password-section {
      background: #fafafa;
      padding: 16px;
      border-radius: 8px;
      margin-bottom: 16px;

      .password-tips {
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: #999;
        font-size: 12px;

        i {
          margin-right: 4px;
        }
      }
    }
  }

  // 选择器选项样式
  .role-option {
    padding: 8px;

    .role-name {
      color: #333;
      font-weight: 500;
    }

    .role-desc {
      color: #999;
      font-size: 12px;
    }
  }

  .status-badge {
    display: flex;
    align-items: center;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 12px;

    i {
      margin-right: 4px;
    }

    &.active {
      background: rgba(82, 196, 26, 0.1);
      color: #52c41a;
    }

    &.inactive {
      background: rgba(245, 34, 45, 0.1);
      color: #f5222d;
    }
  }

  // 按钮样式
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .cancel-btn {
      border-color: #d9d9d9;
      color: #666;

      &:hover {
        border-color: #1890ff;
        color: #1890ff;
        background: rgba(24, 144, 255, 0.05);
      }
    }

    .submit-btn {
      background: linear-gradient(135deg, #1890ff 0%, #52c41a 100%);
      border: none;

      &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  // 输入框美化
  ::v-deep .el-input {
    .el-input__inner {
      border-radius: 6px;
      transition: all 0.3s;
      border: 1px solid #d9d9d9;

      &:focus {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }
    }

    &.is-focus {
      .el-input__inner {
        border-color: #1890ff;
      }
    }
  }

  // 选择器美化
  ::v-deep .el-select {
    .el-input {
      .el-input__inner {
        &:hover {
          border-color: #1890ff;
        }
      }
    }
  }

  // 动画效果
  .el-dialog {
    animation: dialogFadeIn 0.3s ease-out;
  }

  @keyframes dialogFadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // 滚动条美化
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
</style>
